<vex-page-layout-content>
  <div class="p-3">
    <base-data-table-header
      [loading]="loading"
      (onSearchChange)="onSearchChange($event)"
      [canCreate]="false"
      (onClearTextFilter)="clearTextFilter()"
    ></base-data-table-header>

    <base-data-table
      [showPaginator]="true"
      [count]="count"
      [sortField]="sortField"
      [sortOrder]="sortOrder"
      [dataSource]="dataSource"
      [displayedColumns]="displayedColumns"
      [feisColumns]="feisColumns"
      (onPageEvent)="pageEvent($event)"
      (onSortEvent)="sortEvent($event)"
      (onDeleteItem)="deleteItem($event)"
      (onSelectedRow)="selectedRow($event)"
      [selectionActionTemplate]="selectionActionTemplateRef"
      [clearSelectedRow]="clearSelectedRow"
    ></base-data-table>
    <ng-template #selectionActionTemplateRef let-selectedElem>
      <div *ngIf="selectedElem.length > 0" class="card w-full bg-gray-light flex flex-row justify-between mb-4">
        <h4 class="p-4 pl-10 w-full">
          {{ selectedElem.length }} élément{{ selectedElem.length > 1 ? 's' : '' }} sélectionné{{
            selectedElem.length > 1 ? 's' : ''
          }}
        </h4>
        <div class="p-4 pr-10 h-full w-full flex justify-end">
          <button mat-raised-button color="warn" type="button" (click)="deleteSelected()">Supprimer</button>
        </div>
      </div>
    </ng-template>
  </div>
</vex-page-layout-content>
